import { createFileRoute } from "@tanstack/react-router";
import { PublicTournamentDetail } from "@/features/tournaments";
import { loadPublicTournament } from "@/features/game-resources/records";
import {
  resourceHead,
  ResultsFrame,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute("/_site/tournaments/$tournamentId")({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadPublicTournament({
      data: { resourceId: params.tournamentId, search: deps.search },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Tournament results"),
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  const { tournamentId } = Route.useParams();
  return (
    <ResultsFrame viewer={data.viewer}>
      <PublicTournamentDetail
        key={tournamentId}
        tournamentId={tournamentId}
        initialData={data.tournament}
        initialDataUpdatedAt={data.generatedAt}
      />
    </ResultsFrame>
  );
}
